import { render, staticRenderFns } from "./IsolationEdit.vue?vue&type=template&id=08920520&scoped=true&"
import script from "./IsolationEdit.vue?vue&type=script&lang=js&"
export * from "./IsolationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08920520",
  null
  
)

export default component.exports